import { render, staticRenderFns } from "./principles.vue?vue&type=template&id=8220e6c0&scoped=true"
var script = {}
import style0 from "./principles.vue?vue&type=style&index=0&id=8220e6c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8220e6c0",
  null
  
)

export default component.exports